import React, { useState } from 'react'
import injectSheet from 'react-jss'
import styles from './slide-form.styles'
import { Formik, FieldArray } from 'formik'
import FormRow from '../../../common/form-elements/form-row/form-row'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import {
  SortableHolder,
  SortableFormRow
} from './sortable-components/sortable-components'
import Button from 'pobble-components/dist/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons/faTrashAlt'
import { faLightbulbOn } from '@fortawesome/pro-solid-svg-icons/faLightbulbOn'
import * as Yup from 'yup'
import { SuggestedModal } from '../suggested/suggested'

const TITLE_MAX_LENGTH = 60

const defaultCriteria = [
  { criterion: '', prompts: '' },
  { criterion: '', prompts: '' },
  { criterion: '', prompts: '' }
]

let SlideForm = React.memo(({ classes, formikProps }) => {
  const {
    values,
    handleChange,
    handleBlur,
    setFieldValue,
    errors,
    touched
  } = formikProps
  const [isDragging, setDragging] = useState(false)
  const [openSuggested, setOpenSuggested] = useState(false)
  return (
    <>
      <FormRow first>
        <FormLabel small spaceBetween htmlFor="createSuccessCriteriaSlideTitle">
          <span>Title of the slide</span>
          <CharactersCount value={values.title} max={TITLE_MAX_LENGTH} />
        </FormLabel>
        <FormInput
          validationError={touched.title && errors.title}
          name="title"
          placeholder="e.g. I can write an acrostic poem"
          value={values.title}
          onBlur={handleBlur}
          onChange={handleChange}
          maxLength={TITLE_MAX_LENGTH}
        />
        <div>
          <FieldArray
            validateOnChange={false}
            name="criteria"
            render={arrayHelpers => {
              const removeEmptyLines = () => {
                let i = 0
                values.criteria.forEach(criteria => {
                  if (!criteria.criterion) {
                    arrayHelpers.remove(i--)
                  }
                  i++
                })
              }

              return (
                <div className={classes.criteriaWrapper}>
                  <div className={classes.controls}>
                    <Button
                      action={() => setOpenSuggested(true)}
                      simple
                      tall
                      bleed
                      icon={<FontAwesomeIcon icon={faLightbulbOn} />}>
                      Pick from suggestions
                    </Button>
                    <Button
                      action={() => setFieldValue('criteria', defaultCriteria)}
                      className={classes.clearAllButton}
                      tall
                      tertiary
                      bleed
                      icon={<FontAwesomeIcon icon={faTrashAlt} />}>
                      Clear all
                    </Button>
                  </div>
                  <div className={classes.criteriaContainer}>
                    <SortableHolder
                      onSortStart={() => setDragging(true)}
                      className={classes.criteriaList}
                      onSortEnd={({ oldIndex, newIndex }) => {
                        setDragging(false)
                        arrayHelpers.move(oldIndex, newIndex)
                      }}
                      useDragHandle={true}
                      helperClass={classes.sortHelper}>
                      {values.criteria.map((criteria, index) => (
                        <SortableFormRow
                          onDelete={() => arrayHelpers.remove(index)}
                          formikProps={formikProps}
                          isDragging={isDragging}
                          first={index === 0}
                          last={index === values.criteria.length - 1}
                          criterion={criteria.criterion}
                          prompts={criteria.prompts}
                          key={index}
                          index={index}
                          id={index}
                        />
                      ))}
                    </SortableHolder>
                    <Button
                      className={classes.addLineButton}
                      action={() =>
                        arrayHelpers.push({ criterion: '', prompts: '' })
                      }
                      icon={<FontAwesomeIcon icon={faPlusCircle} />}
                      tertiary
                      bleed
                      tall>
                      Add a line
                    </Button>
                  </div>
                  <SuggestedModal
                    onAdd={result => {
                      removeEmptyLines()
                      result.forEach(item =>
                        arrayHelpers.push({
                          criterion: item.criteria || '',
                          prompts: item.prompt || ''
                        })
                      )
                    }}
                    isOpen={openSuggested}
                    requestClose={() => setOpenSuggested(false)}
                  />
                </div>
              )
            }}
          />
        </div>
      </FormRow>
    </>
  )
})

SlideForm = injectSheet(styles)(SlideForm)

const FormSupplier = ({ children, onSubmit, defaultValues = {} }) => (
  <Formik
    onSubmit={onSubmit}
    initialValues={{
      title: defaultValues.title || '',
      criteria: defaultValues.criteria || defaultCriteria
    }}
    validationSchema={Yup.object().shape({
      title: Yup.string().required('Please provide a title')
    })}>
    {formikProps => {
      const { handleSubmit } = formikProps
      return (
        <form onSubmit={handleSubmit} className="metrics__slide-form">
          {children({
            ...formikProps,
            slideForm: <SlideForm formikProps={formikProps} />
          })}
        </form>
      )
    }}
  </Formik>
)

export { SlideForm, FormSupplier }
